const roles = {
  /** @description CRIAR_USUARIO */
  CRIAR_USUARIO: 'CRIAR_USUARIO',

  /** @description IMPORTACAO_PLANILHA */
  IMPORTACAO_PLANILHA: 'IMPORTACAO_PLANILHA',

  /** @description ADMINISTRADOR */
  ADMINISTRADOR: 'ADMINISTRADOR',

  /** @description USUARIO_EXTERNO */
  USUARIO_EXTERNO: 'USUARIO_EXTERNO',

  /** @description USUARIO_EXTERNO */
  MOVIMENTACAO: 'MOVIMENTACAO'
}
export default roles



// WEBPACK FOOTER //
// ./src/shared/utils/roles.js